/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { ParentTabService } from "./parent-tab.service";
import { ChildTabService } from "./child-tab.service";
import { TabUtilsService } from "./utils/tabUtil.service";
import { PostMessageListenerService } from "./utils/postmessage";

@NgModule({
   declarations: [],
   providers: [ParentTabService, ChildTabService, TabUtilsService, PostMessageListenerService]
})
export class TabsModule {}
